/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Injectable} from '@angular/core';
/**
 * A backend for http that uses the `XMLHttpRequest` browser API.
 * 
 * Take care not to evaluate this in non-browser contexts.
 * 
 * \@experimental
 */
export class BrowserXhr {
constructor() {}
/**
 * @return {?}
 */
build(): any { return /** @type {?} */(( <any>(new XMLHttpRequest()))); }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BrowserXhr_tsickle_Closure_declarations() {
/** @type {?} */
BrowserXhr.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BrowserXhr.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../../packages/http/src/backends/browser_xhr.ts